import isArray from "lodash/isArray";
import { collectionCardBgColors } from "../../../utils/constants";
import { CustomButton } from "./CustomButton";
import { CollectionStars } from "./Stars";
import { CollectionTrophy } from "./Trophy";

interface CollectionCardProps {
    index?: number;
    stars?: number;
    collection?: any;
    handlePlay: any;
}

const getBgColor = (i: number) => {
    if (
        !collectionCardBgColors ||
        !isArray(collectionCardBgColors) ||
        !collectionCardBgColors.length
    ) {
        return "bg-mint-cream";
    }
    if (i < collectionCardBgColors.length) {
        return collectionCardBgColors[i].bg;
    }
    return collectionCardBgColors[i % collectionCardBgColors.length].bg;
};

export const CollectionCard: React.FC<CollectionCardProps> = ({
    index = 0,
    stars = 0,
    collection = {},
    handlePlay,
}) => {
    return (
        <div
            className={
                "self-stretch px-3 py-4 mx-4 mt-8 shadow-collection rounded-2xl" +
                " " +
                getBgColor(index)
            }
        >
            <div className="flex flex-row">
                <div className="flex flex-col">
                    <span className="mb-2 mr-2 text-3xl font-semibold text-dark-purple">
                        {collection?.title}
                    </span>
                    <span className="text-xs font-light text-dark-purple">
                        {collection?.description}
                    </span>
                </div>
                <div
                    className={
                        "w-20 h-20 ml-auto rounded-full min-w-80px" +
                        " " +
                        (!collection?.cover ? "bg-gargoyle-gas" : "")
                    }
                >
                    {collection?.cover ? (
                        <img
                            src={collection?.cover}
                            alt="collection"
                            className="object-contain w-full h-full rounded-full"
                        />
                    ) : (
                        <img
                            src={
                                "https://ik.imagekit.io/thehomeworkapp/Sets_Cover/98413-bulb_JdQpaSX9F.gif?ik-sdk-version=javascript-1.4.3&updatedAt=1656680168846&tr=w-75"
                            }
                            alt="collection"
                            className="object-contain w-full h-full rounded-full"
                        />
                    )}
                </div>
            </div>
            <div className="flex flex-row items-center justify-center mb-12 mt-9">
                <div className="flex flex-row mr-6">
                    <CollectionStars stars={stars} className="w-8 h-9" />
                </div>
                <div className="w-16 h-16">
                    <CollectionTrophy stars={stars} bottom="flat" />
                </div>
            </div>
            <div className="flex flex-row justify-center mb-2 mt-14">
                <span className="text-base font-light text-dark-purple">
                    {Math.round(collection?.duration / 60)} min
                </span>
            </div>
            <CustomButton
                cta={collection.submissions.length ? "Replay" : "Play"}
                type={"action"}
                onClick={() => handlePlay(collection)}
            />
        </div>
    );
};
